// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c54ad72","389":"6b106842","732":"a4ad9b7a"}[chunkId] + ".chunk.js";
};